import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import {
  CartList,
  CartSummary,
  AddressManager,
  AddAddressModal,
  CheckoutModal,
  ConfirmationModal,
  ErrorModal,
} from "../components/Cart";
import { useCartCheckout } from "../hooks/useCartCheckout";
import { useNavigate } from "react-router-dom";

const CartCheckoutPage = () => {
  const navigate = useNavigate();
  const {
    // State
    cartItems,
    addresses,
    addressTypes,
    selectedAddress,
    selectedAddressType,
    hasAddresses,
    addressesLoading,
    newAddress,

    // Modal states
    showAddAddressModal,
    showCheckoutModal,
    showConfirmationModal,
    showErrorModal,

    // Loading states
    isLoading,
    cartLoading,
    enhancedLoading,

    // Order response
    orderResponse,

    // Error response
    errorResponse,

    // Calculations
    itemsTotal,
    itemsDiscount,
    subtotal,
    shippingCost,
    estimatedTotal,

    // Handlers
    updateQuantity,
    removeItem,
    handleAddressChange,
    handleAddAddress,
    handleDeleteAddress,
    handleSetDefaultAddress,
    handleCheckout,
    handleConfirmOrder,

    // Editing states
    editingAddressId,
    editingAddressData,

    // Setters
    setSelectedAddress,
    setSelectedAddressType,
    setShowAddressModal,
    setShowAddAddressModal,
    setShowCheckoutModal,
    setShowConfirmationModal,
    setShowErrorModal,
    setEditingAddressId,
    setEditingAddressData,
    setNewAddress,
  } = useCartCheckout();

  // Handler to open AddAddressModal pre-filled for editing an address
  const handleEditAddress = (address: any) => {
    setEditingAddressId(address.id);
    setEditingAddressData(address);
    // Close any address list modal and open the add/edit modal
    setShowAddressModal(false);
    setShowAddAddressModal(true);
    setNewAddress({
      city: address.city || "",
      street: address.street || "",
      floor: address.floor || "",
      building: address.building || "",
      apartment: address.apartment || "",
      description: address.description || "",
      address_type_value: address.address_type_value || "",
      latitude: address.latitude || 0,
      longitude: address.longitude || 0,
      is_default: address.is_default || false,
    });
  };
  return (
    <>
      <Header />
      <div className="max-w-7xl mx-auto p-4 lg:p-6">
        {/* Removed Add Address Type Modal. Now, clicking the add address type button will open the Add Address modal directly. */}

        <AddressManager
          addresses={addresses}
          addressTypes={addressTypes}
          selectedAddress={selectedAddress}
          selectedAddressType={selectedAddressType}
          hasAddresses={hasAddresses}
          addressesLoading={addressesLoading}
          onSelectAddress={setSelectedAddress}
          onSelectAddressType={setSelectedAddressType}
          onShowAddressModal={() => setShowAddressModal(true)}
          onShowAddAddressModal={() => setShowAddAddressModal(true)}
          onShowAddAddressTypeModal={() => setShowAddAddressModal(true)}
          onDeleteAddress={handleDeleteAddress}
          onSetDefaultAddress={handleSetDefaultAddress}
          onEditAddress={handleEditAddress}
        />

        <AddAddressModal
          show={showAddAddressModal}
          newAddress={newAddress}
          setNewAddress={setNewAddress}
          addressTypes={addressTypes}
          isLoading={isLoading}
          editingAddressId={editingAddressId}
          editingAddressData={editingAddressData}
          onClose={() => {
            setShowAddAddressModal(false);
            setEditingAddressId(null);
            setEditingAddressData(null);
          }}
          onAddressChange={handleAddressChange}
          onSubmit={handleAddAddress}
        />

        <CheckoutModal
          show={showCheckoutModal}
          cartItems={cartItems}
          addresses={addresses}
          selectedAddress={selectedAddress}
          hasAddresses={hasAddresses}
          itemsTotal={itemsTotal}
          itemsDiscount={itemsDiscount}
          subtotal={subtotal}
          shippingCost={shippingCost}
          estimatedTotal={estimatedTotal}
          isLoading={isLoading}
          onClose={() => setShowCheckoutModal(false)}
          onSelectAddress={setSelectedAddress}
          onConfirmOrder={handleConfirmOrder}
          onContinueShopping={() => {
            setShowCheckoutModal(false);
            navigate("/products");
          }}
        />

        <ConfirmationModal
          show={showConfirmationModal}
          orderResponse={orderResponse}
          onTrackOrder={() => {
            setShowConfirmationModal(false);
            navigate("/tracking");
          }}
          onContinueShopping={() => {
            setShowConfirmationModal(false);
            navigate("/products");
          }}
        />

        <ErrorModal
          show={showErrorModal}
          title="Order Error"
          message={errorResponse?.message || "An error occurred"}
          onClose={() => setShowErrorModal(false)}
        />

        {/* Main Checkout Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Cart Section */}
          <div className="lg:col-span-2">
            <CartList
              cartItems={cartItems}
              cartLoading={cartLoading}
              enhancedLoading={enhancedLoading}
              onQuantityChange={updateQuantity}
              onRemoveItem={removeItem}
              isLoading={isLoading}
            />
          </div>

          {/* Summary Section */}
          <div className="lg:col-span-1">
            <CartSummary
              cartItems={cartItems}
              itemsTotal={itemsTotal}
              itemsDiscount={itemsDiscount}
              subtotal={subtotal}
              shippingCost={shippingCost}
              estimatedTotal={estimatedTotal}
              onCheckout={handleCheckout}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CartCheckoutPage;
